<ng-container *ngIf="waitingForPayment == true">
    <div class="flex align-items-center justify-content-center flex-1">
        <div class="flex flex-column">
            <h4 class="text-center" i18n="@@payment-shopping-cart.wait-for-payment">Wait for payment confirmation</h4>
            <div class="mt-4 text-center">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <div class="text-center mt-5 justify-content-between flex">
                <div>
                    <p-button label="Cancel" (onClick)="goto.emit('booking')" severity="secondary"
                        i18n-label="@@payment-shopping-cart.wait-for-payment-cancel" severity="secondary"></p-button>
                </div>
                <div>
                    <p-button label="Check" (onClick)="checkForIncomingPayment()"
                        i18n-label="@@payment-shopping-cart.wait-for-payment-check" severity="primary"></p-button>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="waitingForPayment == false">
    <p-dataView [value]="products" layout="list">
        <ng-template let-products #list>
            <div class="col-12 flex flex-column px-3 mb-1"
                [class.surface-ground]="shoppingCartItems[index].quantity == 0"
                *ngFor="let product of products; let index=index">
                <div class="mt-4 flex justify-content-between">
                    <div class="font-semibold text-lg">{{product.name}}</div>
                    <div class="text-right">
                        <p-tag severity="info" value="Test system"
                            i18n-value="@@payment-products-table-status.system.test"
                            *ngIf="product.paymentProviderReference.environment === 'TEST'"
                            styleClass="text-xs"></p-tag>
                    </div>
                </div>
                <div class="mb-4 mt-4 flex ml-1">
                    <div>
                        <div>
                            <img [src]="product.image?.url" class="w-7rem">
                        </div>
                    </div>
                    <div class="ml-3">
                        <div>{{product.description}}</div>
                    </div>
                </div>
                <div class="flex justify-content-between">
                    <div class="font-semibold mt-2 text-lg">{{(product.price.amount *
                        shoppingCartItems[index].quantity / 100) | currency : product.price.currency.toUpperCase()}}
                    </div>

                    <div class="flex align-items-center mb-3">
                        <p-button icon="pi-minus pi" severity="secondary"
                            (onClick)="onChangeCartQuantity(index,-1)"></p-button>
                        <input type="number" [(ngModel)]="shoppingCartItems[index].quantity" [min]="0"
                            [max]="maxQuantity[shoppingCartItems[index].productDefinitionId]"
                            class="p-inputtext p-component p-element inputfield ml-1 mr-1"
                            (ngModelChange)="onCartQuantityChanged(index)">
                        <p-button icon="pi-plus pi" severity="secondary"
                            (onClick)="onChangeCartQuantity(index,1)"></p-button>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #footer>
            <div class="flex align-items-between align-items-center" *ngIf="shoppingCartItems.length>0">
                <div class="flex-1 font-semibold text-lg">

                    <div>
                        <span i18n="@@payment-shopping-cart.sum">Sum:</span><span class="ml-1">{{(cartPrice.amount /
                            100) | currency : cartPrice.currency.toUpperCase()}}</span>
                    </div>
                    <div class="text-xs mt-2" i18n="@@payment-shopping-cart.tax-amount">
                        Inclusive {{(cartPrice.tax / 100) | currency: cartPrice.currency.toUpperCase()}} VAT
                    </div>

                </div>
                <div class="text-right flex-1"><p-button label="Pay" i18n-label="@@payment-shopping-cart.pay"
                        *ngIf="cartPrice.amount > 0" (onClick)="onPay()" severity="secondary"></p-button></div>
            </div>

        </ng-template>
        <ng-template #emptymessage>
            <div class="flex justify-content-center flex-column" style="height: 12rem;">
                <div class="text-center text-2xl" i18n="@@payment-shopping-cart.no-matching-active-product">No matching products could be found, or the product has been removed from sale and is no longer available for purchase.</div>
                <div class="mt-2 text-center">
                    <p-button label="Back" i18n-label="@@payment-shopping-cart.back" (onClick)="goto.emit('booking')"
                        severity="secondary"></p-button>
                </div>
            </div>
        </ng-template>
    </p-dataView>